/* globals jQuery */
import { easing, animSpeed } from './_vars.js';

(function(document, $) {
	$(document).ready(function() {
		$(document).on('click', '.notification-close', function(){
			$(this).parent().fadeTo(animSpeed, 0, easing, function(){
				$(this).remove();
			});
		});
	});	
}(document, jQuery));